// extracted by mini-css-extract-plugin
export var button = "_dq-7";
export var buttonRow = "_dq-6";
export var fadeIn = "_dq-1";
export var gradient = "_dq-0";
export var panel = "_dq-2";
export var panelIn = "_dq-3";
export var subtitle = "_dq-5";
export var title = "_dq-4";